import { lazy } from 'react';
// @ts-ignore
export const NotFoundScreenAsync = lazy(() => import('./NotFoundScreen.tsx'));
